import React, { useContext } from 'react';
import { Chip } from '@material-ui/core';
import { I18nContext } from 'translations';
import { packageStatusLabel } from 'utils/deliveryRoute';

const STATUS_COLOR = {
  waiting_for_pick_up: '#9A68C2',
  picked_up: '#F5A623',
  delivered: '#93ca00',
  returned: '#B0B0B0',
  cancelled: '#E53935',
  not_received: '#E53935',
  not_visited: '#E53935',
};

export default function PackageStatusChip({ status }) {
  const { translate } = useContext(I18nContext);
  const color = STATUS_COLOR[status] || STATUS_COLOR.waiting_for_pick_up;

  return (
    <Chip
      size="small"
      label={packageStatusLabel(status, translate)}
      style={{ backgroundColor: color, color: '#fff', fontWeight: 600 }}
    />
  );
}
